import { useTransform, useViewportScroll, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import useIntersectionObserver from "../loaders/useIntersectionObserver";
import { css } from "@emotion/core";
import clamp from "lodash/clamp";
import GatsbyImage from "gatsby-image";
import { get } from "lodash";
import { graphql, useStaticQuery } from "gatsby";
export default function Parallax({ image, children }) {
  const targetRef = useRef();
  const containerRef = useRef();
  const windowHeight =
    typeof window !== "undefined" ? window.innerHeight : null;

  useEffect(() => {
    function update() {
      if (targetRef.current) {
        let top =
          containerRef.current &&
          containerRef.current.getBoundingClientRect().top;
        let height =
          containerRef.current &&
          containerRef.current.getBoundingClientRect().height;

        if (typeof window !== "undefined" && top && height && windowHeight) {
          let range = height + windowHeight;
          let topTransformed = top + height;
          const value = topTransformed / range;
          targetRef.current.style.transform =
            "translate3d(0," + value * 100 * -1 + "px,0)";
        }
      }
      requestAnimationFrame(update);
    }
    update();
  }, []);

  return (
    <div
      ref={containerRef}
      className="border-t-4 border-accent relative overflow-hidden "
    >
      <div className="relative z-10"> {children}</div>
      <div
        className="target absolute  left-0 top-0 h-full w-full  z-0"
        css={css`
          min-height: calc(100% + 100px);
        `}
        ref={targetRef}
      >
        {get(image, "childImageSharp.fluid") && (
          <GatsbyImage
            css={css`
              img {
                background-position: "top center";
              }
            `}
            className="absolute top-0 left-0 w-full h-full "
            fluid={get(image, "childImageSharp.fluid")}
          />
        )}
      </div>
    </div>
  );
}
